/* Probably Late — About page parallax.
   Every image drifts slowly against the scroll, so the page feels layered.
   Locked to the smoothed scroll position; disabled for reduced motion. */
(function () {
  var imgs = Array.prototype.slice.call(
    document.querySelectorAll('.pl-about__banner-img, .pl-about__image')
  );
  if (!imgs.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var DRIFT = 0.12; // share of the element's height it travels across the viewport

  function update() {
    var vh = window.innerHeight;
    imgs.forEach(function (img) {
      var frame = img.parentElement;
      var r = frame.getBoundingClientRect();
      if (r.bottom < -200 || r.top > vh + 200) return;
      // -1 when the frame is entering, +1 when it is leaving
      var progress = (r.top + r.height / 2 - vh / 2) / (vh / 2 + r.height / 2);
      var shift = -progress * r.height * DRIFT;
      img.style.transform = 'translate3d(0, ' + shift.toFixed(1) + 'px, 0) scale(1.18)';
    });
  }

  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  if (window.plLenis && window.plLenis.on) window.plLenis.on('scroll', update);
  update();
})();
